import React, { FunctionComponent } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import { useAppState } from '../../../contexts/app-state/AppStateContext'
import { videoAnimation } from './animations'
import Vimeo from './vimeo/Vimeo'
import Youku from './youku/Youku'

export interface VideoProps {
  className?: string
  title: string
  vimeoId: string
  youkuId: string
}

const Video: FunctionComponent<VideoProps> = ({
  className,
  title,
  vimeoId,
  youkuId,
}) => {
  const [{ countryCode }] = useAppState()

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  return (
    <StyledVideo
      animate={inView ? ['opacityIn', 'transformIn'] : 'initial'}
      className={className}
      ref={ref}
      variants={videoAnimation}
    >
      {countryCode === 'cn' ? (
        <Youku id={youkuId} title={title} />
      ) : (
        <Vimeo id={vimeoId} title={title} />
      )}
    </StyledVideo>
  )
}

const StyledVideo = styled(motion.div)`
  position: relative;
  padding-bottom: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export default Video
